// @helpers
const apiURLBuilder = require('core/apiURLBuilder');

// @utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { getPersonTypeAndCodeHashed } = require('utilities/hash');
const getCallbackUrl = require('../../utilities/aggregator/getCallbackUrl');

// @constant
const {
    AGGREGATOR_ADD_ENTITY_PSD2_INIT,
    AGGREGATOR_ADD_ENTITY_PSD2_GET_URL_REQUEST,
    AGGREGATOR_ADD_ENTITY_PSD2_GET_URL_SUCCESS,
    AGGREGATOR_ADD_ENTITY_PSD2_GET_URL_FAILURE,
    AGGREGATOR_ADD_ENTITY_PSD2_GET_TOKEN_REQUEST,
    AGGREGATOR_ADD_ENTITY_PSD2_GET_TOKEN_SUCCESS,
    AGGREGATOR_ADD_ENTITY_PSD2_GET_TOKEN_FAILURE
} = require('constants/actionTypes');

const initStorePSD2 = () => ({
    type: AGGREGATOR_ADD_ENTITY_PSD2_INIT,
})

const getIsUrlFetching = isFetchingUrl => ({
    type: AGGREGATOR_ADD_ENTITY_PSD2_GET_URL_REQUEST,
    payload: isFetchingUrl,
})

const getUrlSuccess = (response) => ({
    type: AGGREGATOR_ADD_ENTITY_PSD2_GET_URL_SUCCESS,
    payload: response
})

const getUrlFailure = (error) => ({
    type: AGGREGATOR_ADD_ENTITY_PSD2_GET_URL_FAILURE,
    payload: error
})

const requestUrl = (robotCode, userBankId) => (dispatch) => {
    const url = apiURLBuilder.getURL('aggregatorPSD2GetUrl',{userId: getPersonTypeAndCodeHashed()});
    const callbackURL = getCallbackUrl(window.__ENV__, 'myprofile/global/entities/add/callback')
    const requestData = {
        query: {
            robotCode,
            userBankId,
            callbackUri: callbackURL
        }
    }

    dispatch(getIsUrlFetching(true))
    
    return APIPost(dispatch, url, requestData).then(
        response => {
            dispatch(getUrlSuccess(response))
            dispatch(getIsUrlFetching(false))
        },
        error => {
            dispatch(getUrlFailure(error))
            dispatch(getIsUrlFetching(false))
        }
    );
}

const getIsTokenFetching = isFetchingToken => ({
    type: AGGREGATOR_ADD_ENTITY_PSD2_GET_TOKEN_REQUEST,
    payload: isFetchingToken,
})

const getTokenSuccess = (response) => ({
    type: AGGREGATOR_ADD_ENTITY_PSD2_GET_TOKEN_SUCCESS,
    payload: response
})

const getTokenFailure = (error) => ({
    type: AGGREGATOR_ADD_ENTITY_PSD2_GET_TOKEN_FAILURE,
    payload: error
})

const requestToken = (bankUniqueId, state, code) => (dispatch) => {
    const url = apiURLBuilder.getURL('aggregatorPSD2GetToken', {userId: getPersonTypeAndCodeHashed()});
    const requestData = {
        query: {
            code,
            "robotCode": bankUniqueId,
            state 
        }
    }

    dispatch(getIsTokenFetching(true))

    return APIPost(dispatch, url, requestData).then(
        response => {
            dispatch(getTokenSuccess(response))
            dispatch(getIsTokenFetching(false))
        },
        error => {
            dispatch(getTokenFailure(error))
            dispatch(getIsTokenFetching(false))
        }
    );
}

export { requestUrl, requestToken, initStorePSD2 };